import * as React from 'react';
import axios from 'axios';
import { GET_ERRORS, SET_CURRENT_ORGANIZATION, GET_ORGANIZATIONS_LIST } from './types';
const api_url = process.env.REACT_APP_API_URL;


export const addOrganization = (organization, history) => dispatch => {
    axios.post(api_url+'organizations/add', organization)
            .catch(err => {
                dispatch({
                    type: GET_ERRORS,
                    payload: err.response.data
                });
            });
}

export const listOrganizations = (organization) => dispatch => {
  // console.log(organization);
  axios({
      url: api_url+'organizations/list',
  })
  .then(response => {
      // console.log('api_url',api_url);
      // console.log('response.data');
      // console.log(response.data);
      // console.log('response.data');
      dispatch({
          type: GET_ORGANIZATIONS_LIST,
          payload: response.data
      });
  });
}
//
//
//
export const setCurrentOrganization = organization => {
    return {
        type: SET_CURRENT_ORGANIZATION,
        payload: organization
    }
}
